import axios from 'axios'
import environment from '../environments/environment';

axios.interceptors.response.use(

  undefined,
  error => {

    if(error.response){

      const { data, status } = error.response;
      if(status == '401' && !data.auth){
        window.location.href = '/login';
        // localStorage.removeItem('userappret');
        localStorage.clear();

      }

    }else{
      // window.location.reload();
      console.log('error en response', error.message);
    }

    return Promise.reject(error);
  }
)

// console.log("process.env.NODE_ENV", process.env.NODE_ENV )
let BASE_URL = environment.api.host;

const AuthService = {

  login: async (username, password, recaptcha) => {

    try {
      const body = { username, password, recaptcha }
      console.log("BASE_URL", BASE_URL)
      console.log("url", `${BASE_URL}/user/login`)
      console.log("body", body)
      const { data } = await axios.post(`${BASE_URL}/user/login`, body)
      console.log('DATA',data);
      return data
    } catch (e) {
      console.log("ERROR")
      console.log(e.response);
      return e.response;
    }
  },

  // Servicio para llamar al api de cesarr seción
  logout: async (token) => {
    localStorage.removeItem('time');
    try {
      const response = await axios.post(`${BASE_URL}/user/logout`, {
        headers: { Authorization: "Bearer " + token }
      })
      console.log(response);
      return response;
    } catch (e) {

      return e;
    }
  },

  // Servicio para llamar al api user/refresh-token
  refreshToken: async (token) => {
    try {
      const response = await axios.post(`${BASE_URL}/user/refresh-token`, {
        headers: { Authorization: "Bearer " + token }
      })
      console.log(response.data);
      return response;
    } catch (e) {
      return e;
    }
  }
}

export default AuthService
